(() => {
  if (window.__colorboxOverlaysLoaderInstalled) return;
  window.__colorboxOverlaysLoaderInstalled = true;

  const overlaysAssetUrl = window.__colorboxOverlaysAssetUrl;
  const LOADING_ID = 'colorbox-overlays-loading';
  let loadPromise = null;
  let warmupScheduled = false;

  const isReady = () => Boolean(window.ColorboxOverlays?.isReady?.());

  const ensureLoaded = () => {
    if (isReady()) {
      return Promise.resolve(window.ColorboxOverlays.ensureReady());
    }

    if (!loadPromise) {
      loadPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = overlaysAssetUrl;
        script.async = true;
        script.onload = () => {
          Promise.resolve(window.ColorboxOverlays?.ensureReady?.()).then(resolve).catch(reject);
        };
        script.onerror = () => reject(new Error('Failed to load Colorbox overlays asset.'));
        document.head.appendChild(script);
      }).catch((error) => {
        loadPromise = null;
        throw error;
      });
    }

    return loadPromise;
  };

  const ensureLoadingStyles = () => {
    if (document.getElementById('colorbox-overlays-loading-style')) return;

    const style = document.createElement('style');
    style.id = 'colorbox-overlays-loading-style';
    style.textContent = `
      #${LOADING_ID} {
        position: fixed;
        inset: 0;
        z-index: 9999;
        display: none;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.2);
      }

      #${LOADING_ID}.is-visible {
        display: flex;
      }

      #${LOADING_ID} .colorbox-overlays-loading__card {
        min-width: 148px;
        border-radius: 18px;
        background: #fff;
        padding: 18px 20px;
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.16);
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
      }

      #${LOADING_ID} .colorbox-overlays-loading__spinner {
        width: 26px;
        height: 26px;
        border-radius: 9999px;
        border: 2px solid rgba(0, 0, 0, 0.14);
        border-top-color: #111;
        animation: colorbox-overlays-spin 0.8s linear infinite;
      }

      #${LOADING_ID} .colorbox-overlays-loading__label {
        font: 500 14px/1.2 Jost, system-ui, sans-serif;
        color: #111;
      }

      @keyframes colorbox-overlays-spin {
        to {
          transform: rotate(360deg);
        }
      }
    `;
    document.head.appendChild(style);
  };

  const ensureLoadingNode = () => {
    let node = document.getElementById(LOADING_ID);
    if (node) return node;

    ensureLoadingStyles();
    node = document.createElement('div');
    node.id = LOADING_ID;
    node.setAttribute('aria-hidden', 'true');
    node.innerHTML = `
      <div class="colorbox-overlays-loading__card">
        <div class="colorbox-overlays-loading__spinner"></div>
        <div class="colorbox-overlays-loading__label">Loading ...</div>
      </div>
    `;
    document.body.appendChild(node);
    return node;
  };

  const showLoading = () => {
    ensureLoadingNode().classList.add('is-visible');
  };

  const hideLoading = () => {
    document.getElementById(LOADING_ID)?.classList.remove('is-visible');
  };

  const warmup = () =>
    ensureLoaded()
      .then(() => Promise.resolve(window.ColorboxOverlays?.preload?.()))
      .catch(() => {});

  const scheduleWarmup = () => {
    if (warmupScheduled) return;
    warmupScheduled = true;
    warmup();
  };

  const findOpenTrigger = (target) =>
    target instanceof Element
      ? target.closest('[data-open-shade-dialog], [data-open-shade-usage-dialog]')
      : null;

  document.addEventListener('click', (event) => {
    const trigger = findOpenTrigger(event.target);
    if (!trigger || isReady()) return;

    event.preventDefault();
    event.stopPropagation();
    showLoading();

    ensureLoaded()
      .then(() => {
        hideLoading();
        trigger.dispatchEvent(new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        }));
      })
      .catch((error) => {
        hideLoading();
        console.error(error);
      });
  }, true);

  ['mouseover', 'touchstart', 'focusin'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      if (!findOpenTrigger(event.target) || isReady()) return;
      scheduleWarmup();
    }, { passive: true, capture: true });
  });
})();
